import { IMedicalRecordCID } from './summary.view-model';

export type Procedure = {
  id: string;
  code: string;
  description: string;
  quantity: number;
  isManual?: boolean;
};

export interface CreateProcedure {
  id?: string;
  code?: string;
  description?: string;
  quantity: number;
  source_procedure_combo_id?: string;
  is_apac: boolean;
  is_sadt: boolean;
  temp: boolean;
  version?: string;
}

export interface CreateProcedureForm {
  patient_id: string;
  requisition_id: string;
  diagnosis_description?: string;
  primary_cid_id: string;
  secondary_cid_id?: string;
  other_cid_id?: string;
  note?: string;
  medical_referral_type: number;
  medical_referral_specialization?: string;
  days_for_return?: number;
  procedures?: CreateProcedure[];
}

export type FormBase = {
  patientId: string;
  procedures: Procedure[];
  diagnosisDescription: string;
  primaryCid10: IMedicalRecordCID;
  secondaryCid10: IMedicalRecordCID;
  otherCid10: IMedicalRecordCID;
  note?: string;
  manualProcedures?: Procedure[];
  manualProcedureDescription?: string;
  medical_referral_specialization?: number | string;
  medical_referral_type: number;
  days_for_return?: number;
};

export interface ReferralGuideForm {
  patient_id: string;
  specialty_id: string;
  reason: string;
  cid_id: string;
  note?: string;
  type: number;
  days_for_return?: number;
  requisition_id: string;
}

export type ItemBase = {
  id: string;
  type: string;
  created_at: string;
  speciality?: string;
};

export enum EMedicalReferralType {
  Forwarding = 1,
  Return = 2,
  FollowUp = 3,
  Fitting = 4,
  Exam = 5,
}

export enum EMedicalReferralStringType {
  Forwarding = 'Forwarding',
  Return = 'Return',
  FollowUp = 'FollowUp',
  Fitting = 'Fitting',
  Exam = 'Exam',
}

export enum EGuideContext {
  PATIENT = 'PATIENT',
  REQUISITION = 'REQUISITION',
}

export type ApacForm = CreateProcedureForm;
export type SADTForm = CreateProcedureForm;

export type ApacItem = ItemBase;
export type SADTItem = ItemBase;
export type GuideItem = ItemBase;
